import { createApp } from 'vue'
import i18n from './i18n'
import { createVuestic, useGlobalConfig } from 'vuestic-ui'

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from '../vuestic-ui/global-config'
import App from './App.vue'

const app = createApp(App)

app.use(stores)
app.use(router)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))
app.mount('#app')

// add pagination color config
const { mergeGlobalConfig } = useGlobalConfig()

mergeGlobalConfig({
  components: {
    presets: {
      VaPagination: {
        oiPagination: {
          color: 'success',
          activePageColor: '#163602ff',
        },
      },
    },
  },
})
